import AuthenticationItem from './AuthenticationItem'

export default AuthenticationItem
